import React from "react";
import { SecondryHeadingVector } from "./Icons";
import {
    GroupChat,
    PromoInvite,
    RealFeedback,
    SocialInteractions,
    ViaCode
  } from "./Icons";

const IncentivePromotions = () => {
    const promotionsCards = [
        {
          icon: <PromoInvite />,
          title: "Track who is attending your seminar",
          description: "Directly send a customized link to your registration page..",
        },
        {
          icon: <GroupChat />,
          title: "Tons of great venues",
          description:
            "Choose a venue with logistics and check-in handled. Simply Book a Date, Time, and Venue",
        },
        {
          icon: <ViaCode />,
          title: "Invite Link",
          description:
            "Get a public sales page to invite attendees",
        },
        {
          icon: <RealFeedback />,
          title: "Request to Get Feedback from Attendees ",
          description:
            "Reviews and discuss how it went post event",
        },
        {
          icon: <SocialInteractions />,
          title: "Get Leads ",
          description:
            "Purchase high intent leads to close in meetings or within a seminar or webinar",
        },
      ];
  return (
    <div className="container container_modified">
      <h2 className="text-black fw-bolder font-xxl text-center mt-4 mb-md-1 py-1 position-relative z-1">
        <span className=" d-inline-block position-absolute center__absolute_content ">
          <SecondryHeadingVector />
        </span>
        Why IncentiveMeet 
      </h2>
      <div className="row justify-content-center">
        {promotionsCards.map((obj, index) => (
          <div
            className={`mb-3 mb-md-4 ${
              index === 3 || index === 4 ? "col-sm-6" : "col-sm-6 col-lg-4"
            }`}
            key={index}>
            <div className="tools_card transition_03s bg-white d-flex flex-column align-items-center text-center h-100">
              <span className="cards_circle position-relative">{obj.icon}</span>
              <h3 className="font-lg fw-bold mt-4 mt-md-3 pt-0 pt-md-1 ">
                {obj.title}
              </h3>
              <p className="text-gray font-sm mb-0">{obj.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IncentivePromotions;
